import Icon from "@ant-design/icons";
import React from "react";

export default function FalsePositiveIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5ZM4 12C4 7.58173 7.58173 4 12 4C16.4183 4 20 7.58173 20 12C20 16.4183 16.4183 20 12 20C7.58173 20 4 16.4183 4 12ZM12 7C12.4142 7 12.75 7.33579 12.75 7.75V9.25H14.25C14.6642 9.25 15 9.58579 15 10C15 10.4142 14.6642 10.75 14.25 10.75H12.75V12.25C12.75 12.6642 12.4142 13 12 13C11.5858 13 11.25 12.6642 11.25 12.25V10.75H9.75C9.33579 10.75 9 10.4142 9 10C9 9.58579 9.33579 9.25 9.75 9.25H11.25V7.75C11.25 7.33579 11.5858 7 12 7ZM9 15.25C9 14.8358 9.33579 14.5 9.75 14.5H14.25C14.6642 14.5 15 14.8358 15 15.25C15 15.6642 14.6642 16 14.25 16H9.75C9.33579 16 9 15.6642 9 15.25Z"
        fill="currentColor"
      />
    </svg>
  );
};
